














































import { FormDeFechamentoDeCaixa } from '@/models'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { Vue, Component } from 'vue-property-decorator'

const TAMANHO_MAXIMO_KB = 10000
const TIPOS_PERMITIDOS = [
	'application/pdf',
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]

@Component
export default class DialogoDeAnexarArquivosNoFechamento extends Vue {
    mostra = false
    file: File | null = null
    fechamentos: FormDeFechamentoDeCaixa | null = null
    erroDeArquivo = ''

	readonly regrasDeArquivo = [
		(arquivo: File) => !arquivo || TIPOS_PERMITIDOS.includes(arquivo.type) || 'Apenas arquivos PDF ou Word são permitidos.',
		(arquivo: File) => !arquivo || arquivo.size <= TAMANHO_MAXIMO_KB * 1024
		|| `O arquivo deve ter no máximo ${TAMANHO_MAXIMO_KB}KB.`,
	]

	mostrar(fechamento: FormDeFechamentoDeCaixa) {
		this.mostra = true
		this.fechamentos = { ...fechamento }
	}

	esconder() {
		this.mostra = false
		this.file = null
		this.erroDeArquivo = ''
	}

	get nomeUsuarioLogado(): string | undefined {
		return UserLoginStore.usuario?.nome || undefined
	}

	validarArquivo(arquivo: File | null) {
		this.erroDeArquivo = ''

		if (!arquivo) return

		if (!TIPOS_PERMITIDOS.includes(arquivo.type)) {
			this.erroDeArquivo = 'Apenas arquivos PDF ou Word são permitidos.'
			return
		}

		if (arquivo.size > TAMANHO_MAXIMO_KB * 1024) {
			this.erroDeArquivo = `O arquivo deve ter no máximo ${TAMANHO_MAXIMO_KB}KB.`
		}
	}

	salvar() {
		if (!this.file || this.erroDeArquivo) return

		const novoNome = `${this.file.name}_${this.nomeUsuarioLogado}`
		const novoArquivo = new File(
			[this.file],
			novoNome,
			{ type: this.file.type },
		)
		this.$emit('salvar', novoArquivo)
		this.esconder()
	}
}
